import React from "react";
import PropTypes from "prop-types";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import CprCardHeader from "./CprCardHeader";

const propTypes = {
  cpr: PropTypes.object.isRequired,
  promptText: PropTypes.string,
};
CprDateInfo.prototype = propTypes;

export default function CprDateInfo(props) {
  return (
    <Box mt={3} mb={1} pl={3} pr={1}>
      {props.promptText && (
        <Typography variant="h5" color="#1a247e" fontWeight="600" mb={1}>
          {props.promptText}
        </Typography>
      )}
      <Box p={1}>
        <CprCardHeader cpr={props.cpr} hideActions={true} hideAvatar={true} />
      </Box>
    </Box>
  );
}
